import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useFormState } from "react-final-form";

import { DateTime } from "@bps/date-time";
import { Text, useTheme } from "@bps/fluent-ui";
import { AppointmentFormValues } from "@shared-types/booking/appointment-form-values.types.ts";

import { AppointmentFormContext } from "../context/AppointmentFormContext.ts";

/**
 * Displays an error message if the user moves a single appointment after the next in its series
 */
export const RecurrenceOutOfError = observer(() => {
  const theme = useTheme();

  const { nextRecurrenceDates } = useContext(AppointmentFormContext);

  const { values, submitFailed } = useFormState<AppointmentFormValues>();
  const appointmentDate = values.startDate
    ? DateTime.fromJSDateAndTime(values.startDate, values.startTime)
    : undefined;

  if (
    submitFailed &&
    appointmentDate &&
    nextRecurrenceDates?.next &&
    appointmentDate > nextRecurrenceDates.next
  ) {
    return (
      <Text
        styles={{
          root: { color: theme.semanticColors.errorText, fontSize: 12 }
        }}
      >
        The appointment must occur before the next appointment in the series
      </Text>
    );
  }

  return null;
});
